import React from 'react';
import { useParams } from 'react-router-dom';

function useCaseIdParam() {
  const { caseId } = useParams<{ caseId: string }>();
  return caseId;
}

export default useCaseIdParam;
